export default __webpack_public_path__ + "static/media/page.0b878724.mp3";